import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'

export class SizeGuide extends UcoastEl {
    static htmlSelector = 'size-guide'

    closeButton: HTMLButtonElement
    genderButtons: NodeListOf<HTMLButtonElement>
    sizeValues: NodeListOf<HTMLElement>
    openButtons: NodeListOf<HTMLButtonElement>

    constructor() {
        super()

        this.closeButton = q.rs('.size-guide__drawer-close', this)
        this.genderButtons = q.rl('.size-guide__drawer-gender', this)
        this.sizeValues = q.rl('span[data-gender]', this)
        this.openButtons = document.querySelectorAll('.size-guide__drawer-open')

        this.closeButton.addEventListener('click', this.close.bind(this))
        this.genderButtons.forEach(genderButton => {
            genderButton.addEventListener('click', this.onChangeValue.bind(this))
        })
        this.openButtons.forEach(openButton => {
            openButton.addEventListener('click', this.open.bind(this))
        })
        this.addEventListener('click', this.onClickBody.bind(this))
    }

    open() {
        this.classList.add('active')
    }

    close(e: Event) {
        this.classList.remove('active')
    }

    onChangeValue(e: Event) {
        const target = e.currentTarget as HTMLButtonElement
        if(!target) return
        const gender = target.dataset.gender
        this.sizeValues.forEach(size => {
            size.classList.toggle('hidden', size.dataset.gender != gender)
        })
        this.genderButtons.forEach(genderButton => {
            genderButton.classList.remove('active')
        })
        target.classList.add('active')
    }

    onClickBody(e: Event) {
        const target = e.target as HTMLElement
        if(!target) return
        if(target.closest('.size-guide__drawer')) return
        this.close(e)
    }
}
